import { branchHeaderClasses } from './styles';

export interface BranchHeaderProps {
  /** Zero-based branch index; the component renders index + 1. */
  index: number;
}

/**
 * LF360-1823: the "Branch N" section label (Figma node 14328:41238). It
 * replaces both the left-gutter number and the green "Then -> Branch N" pill
 * that LF360-1817 introduced.
 */
export const BranchHeader = ({ index }: BranchHeaderProps) => (
  <div className={branchHeaderClasses()}>Branch {index + 1}</div>
);
